const e = "__sentry_error_options__";
function o(n) {
  if (typeof n != "object" || n === null)
    return { send: !0 };
  if (e in n) {
    const t = n[e];
    return typeof t == "boolean" ? { send: t } : t;
  }
  return { send: !0 };
}
export {
  e as S,
  o as g
};
//# sourceMappingURL=sentry.js.map
